// dependencies imports ⇒
import React from "react";
// assets and scss imports ⇒
import "./customSectionView.scss";
import AddIcon from "../../../../assets/rx_add.svg";
// project file imports(UI components) ⇒
import CustomCreatableMultiSelect from "../../common/CustomCreatableMultiSelect";

// const file imports(helper methods, etc) ⇒

const CustomSectionView = (props) => {
  // const declarations ⇒
  const { sectionName, selectedCustomSection, handleCustomSection } = props;
  // let or var declarations ⇒

  // life cycle methods ⇒

  // API Calls ⇒

  // Helper methods ⇒

  // Actions ⇒
  const handleOnChange = (key, val, field_id) => {
    let tempCustomSection = [...selectedCustomSection.fields];
    let index = tempCustomSection.findIndex(
      (data) => data.field_id === field_id
    );
    if (index > -1) {
      tempCustomSection[index].value = val;
    }
    handleCustomSection(true, sectionName, [...tempCustomSection]);
  };

  const handleCustomInput = (name, value, field_id) => {
    let obj = {
      ...value,
      title: value?.value,
    };
    let tempCustomSection = [...selectedCustomSection.fields];
    let index = tempCustomSection.findIndex(
      (field) => field?.field_id === field_id
    );
    let isValueDuplicate = tempCustomSection[index].value.filter(
      (ele) =>
        ele.value?.trim()?.toLowerCase() === value?.value?.trim()?.toLowerCase()
    );
    if (index > -1) {
      if (tempCustomSection[index].value.length > 0) {
        if (isValueDuplicate.length === 0) {
          value["id"] =
            tempCustomSection[index].value[
              tempCustomSection[index].value.length - 1
            ].id + 1;
        }
      } else {
        value["id"] = 1;
      }
      if (value?.id) {
        tempCustomSection[index].value = [
          ...tempCustomSection[index].value,
          obj,
        ];
        handleCustomSection(true, sectionName, [...tempCustomSection]);
      }
    }
  };

  const handleAddField = () => {
    let data = [...selectedCustomSection.fields];
    let obj = {
      field_id: selectedCustomSection?.fields?.length + 1,
      field_title: `Edit Field 0${selectedCustomSection?.fields?.length + 1}`,
      value: [],
    };
    data.push(obj);
    handleCustomSection(true, sectionName, [...data]);
  };

  const handleRemove = (key) => {
    let data = [...selectedCustomSection?.fields];
    data.splice(key, 1);
    data.forEach((editkey, index) => {
      editkey.field_title =
        editkey?.field_title == "Edit Field 01" ||
        editkey?.field_title == "Edit Field 02" ||
        editkey?.field_title == "Edit Field 03"
          ? `Edit Field 0${index + 1}`
          : editkey?.field_title;
      editkey.field_id = index + 1;
    });
    handleCustomSection(true, sectionName, [...data]);
  };

  const handleLabelInputChange = (value, field_id) => {
    let tempCustomSection = [...selectedCustomSection.fields];
    let index = tempCustomSection.findIndex(
      (data) => data.field_id === field_id
    );
    if (index > -1) {
      tempCustomSection[index].field_title = value;
    }
    handleCustomSection(true, sectionName, [...tempCustomSection]);
  };

  // create UI ⇒

  const renderAddFieldButton = () => {
    return (
      <button className="add-column-btn py-2" onClick={handleAddField}>
        <img src={AddIcon} alt="" className="mx-2" />
        Add Field{" "}
      </button>
    );
  };

  const customSectionUI = () => {
    return (
      <div>
        {selectedCustomSection?.fields?.map((data, index) => (
          <div className="csv-list" key={index}>
            <CustomCreatableMultiSelect
              name={sectionName}
              inputLabel={data?.field_title}
              options={[]}
              menuIsOpen={false}
              value={data?.value}
              showDelete={true}
              deletePositionAtHeading={true}
              handleLabelInputChange={(value) =>
                handleLabelInputChange(value, data?.field_id)
              }
              handleOnChange={(key, val) =>
                handleOnChange(key, val, data?.field_id)
              }
              handleRemove={() => handleRemove(index)}
              handleCustomInput={(name, value) =>
                handleCustomInput(name, value, data?.field_id)
              }
            />
          </div>
        ))}
        {selectedCustomSection.fields?.length < 3 && (
          <div className="d-flex justify-content-end">
            {renderAddFieldButton()}
          </div>
        )}
      </div>
    );
  };
  return <div className="custom-section-view">{customSectionUI()}</div>;
};

// export ⇒

export default CustomSectionView;
